import { useTranslation } from "react-i18next";

const ARROW_BUTTON_LARGE =
  "inline-flex h-10 w-10 items-center justify-center rounded-full border border-[#e5e7eb] bg-none text-[#e5e7eb] transition-colors disabled:cursor-not-allowed disabled:border-gray-50 disabled:hover:bg-transparent hover:bg-gray-100 active:bg-gray-200";
const ARROW_BUTTON_SMALL =
  "inline-flex h-8 w-8 items-center justify-center rounded-full border border-[#e5e7eb] bg-none text-[#e5e7eb] transition-colors disabled:cursor-not-allowed disabled:border-gray-50 disabled:hover:bg-transparent hover:bg-gray-100 active:bg-gray-200";

type Props = {
  size: "large" | "small";
  canScrollLeft: boolean;
  canScrollRight: boolean;
  onScrollLeft: () => void;
  onScrollRight: () => void;
};

function ScrollArrowButtons(props: Props) {
  const { size, canScrollLeft, canScrollRight, onScrollLeft, onScrollRight } = props;
  const { t } = useTranslation();
  const buttonClass = size === "large" ? ARROW_BUTTON_LARGE : ARROW_BUTTON_SMALL;

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        aria-label={t("Scroll left")}
        className={buttonClass}
        onClick={onScrollLeft}
        disabled={!canScrollLeft}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>
      <button
        type="button"
        aria-label={t("Scroll right")}
        className={buttonClass}
        onClick={onScrollRight}
        disabled={!canScrollRight}
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>
    </div>
  );
}

export default ScrollArrowButtons;
